/**
 * PATH: apps/quote/src/components/builder/application-selector-modal/types.ts
 * PURPOSE: Types and constants for ApplicationSelectorModal
 */

import type { Application } from '@/lib/quoteApi'

export interface ApplicationSelectorModalProps {
  isOpen: boolean
  onClose: () => void
  onSelect: (application: Application) => void
  context?: {
    description?: string
    area?: string
    substrate?: string
    exposure?: string
  }
  selectedId?: string | null
}

export interface FilterState {
  areaType: string
  substrateType: string
  exposureType: string
  supplierId: string
  categoryId: string
}

export const INITIAL_FILTERS: FilterState = {
  areaType: 'all',
  substrateType: 'all',
  exposureType: 'all',
  supplierId: 'all',
  categoryId: 'all',
}

export const AREA_TYPES = [
  { value: 'all', label: 'All Areas' },
  { value: 'internal', label: 'Internal' },
  { value: 'external', label: 'External' },
  { value: 'below_grade', label: 'Below Grade' },
  { value: 'remedial', label: 'Remedial' },
]

export const SUBSTRATE_TYPES = [
  { value: 'all', label: 'All Substrates' },
  { value: 'concrete', label: 'Concrete' },
  { value: 'timber', label: 'Timber' },
  { value: 'steel', label: 'Steel' },
  { value: 'masonry', label: 'Masonry' },
  { value: 'mixed', label: 'Mixed' },
]

export const EXPOSURE_TYPES = [
  { value: 'all', label: 'All Exposures' },
  { value: 'internal', label: 'Internal' },
  { value: 'external', label: 'External' },
  { value: 'buried', label: 'Buried' },
  { value: 'submerged', label: 'Submerged' },
]
